// extracted by mini-css-extract-plugin
export default {"type":"TitleTyping_type__p4vbs","animated-text":"TitleTyping_animated-text__Puodn","animated-cursor":"TitleTyping_animated-cursor__xW2Jv"};